<template>
	<div class="background">
		<a
			class="background-hex"
			title="background Color"
			:class="{
				border: backgroundColors.hex === '#FFFFFF' && !transparent,
				dark: backgroundDark
			}"
			:style="{backgroundColor}"
			@click="colorpicker = colorpicker = !colorpicker"
		>
			{{ backgroundColors.hex }}
			<div class="background-hex-line" v-if="transparent"></div>
		</a>

		<a
			class="background-trans"
			title="Transparent"
			:class="{active: transparent}"
			@click="transparent = !transparent"
			v-html="icon('frame')"
		>
		</a>

		<transition name="fade">
			<div class="background-picker" v-if="colorpicker && !transparent">
				<colorpicker v-model="backgroundColors"></colorpicker>
			</div>
		</transition>
	</div>
</template>

<script>
import {Chrome as colorpicker} from "vue-color";

export default {
	components: {colorpicker},
	props: {
		item: {type: Object, required: true},
		backgroundColor: {type: String}
	},
	data() {
		return {
			colorpicker: false,
			colors: false
		};
	},
	computed: {
		backgroundColors: {
			get() {
				return this.$store.state.backgroundColors;
			},
			set(data) {
				this.$store.setBackgroundColors(data);
			}
		},

		transparent: {
			get() {
				return this.$store.state.transparent;
			},
			set(data) {
				this.$store.setTransparent(data);
				this.colorpicker = false;
			}
		},

		backgroundDark() {
			const rgb = this.backgroundColors.rgba;
			if (this.transparent) return false;
			return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000 < 170
				? true
				: false;
		}
	},
	methods: {
		click(e) {
			if (!this.$el.contains(e.target)) this.colorpicker = false;
		}
	},
	mounted() {
		window.addEventListener("click", this.click);
	},
	destroyed() {
		window.removeEventListener("click", this.click);
	}
};
</script>

<style lang="scss" scoped>
.background {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.9em;
	user-select: none;

	@include res {
		font-size: 1em;
	}

	&-hex {
		position: relative;
		font-size: 0.8em;
		padding: 0.2em 0.5em;
		border-radius: $radius1;
		user-select: none;
		border: 1px solid transparent;
		margin-right: 0.8em;
		transition: background-color 0.05s ease-in-out, color 0.05s ease-in-out;
		width: 5.5em;
		display: flex;
		justify-content: center;
		align-items: center;

		&.border {
			border-color: $greylight2;
		}

		&.dark {
			color: $white1;
		}

		&-line {
			position: absolute;
			left: 0;
			right: 0;
			margin: auto;
			width: 80%;
			top: 50%;
			// transform: translateY(-50%) rotate(-8deg);
			border-top: 1px solid $color2;
		}
	}

	&-trans {
		user-select: none;
		display: inline-flex;

		::v-deep {
			svg {
				$s: 1em;
				width: $s;
				height: $s;
				path {
					fill: $grey1;
					transition: fill 0.05s ease-in-out;
				}
			}
		}

		&.active {
			::v-deep {
				svg {
					path {
						fill: $green1;
					}
				}
			}
		}
	}

	&-picker {
		z-index: 2;
		position: absolute;
		top: calc(100% + 1em);
		left: 50%;
		transform: translateX(-50%);
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: transform 0.2s ease, opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
	transform: translateY(-7px) translateX(-50%);
	opacity: 0;
}
</style>
